/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectResponseDto } from '../../models/core-project-response-dto';
import { CoreProjectUpdateDto } from '../../models/core-project-update-dto';

export interface ProjectsControllerUpdate$Params {
  tenant: string;
  id: string;
      body: CoreProjectUpdateDto
}

export function projectsControllerUpdate(http: HttpClient, rootUrl: string, params: ProjectsControllerUpdate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, projectsControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreProjectResponseDto>;
    })
  );
}

projectsControllerUpdate.PATH = '/o2-core/projects/{tenant}/id/{id}';
